import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {localImages, stringsList} from "../../constants/app-config";
import { log } from 'console';

@Component({
  selector: 'app-small-dialog',
  templateUrl: './small-dialog.component.html',
  styleUrls: ['./small-dialog.component.css',
  '../../styles/styles.css']
})
export class SmallDialogComponent implements OnInit {
  stringsList = stringsList
  localImages = localImages
  showCloseButton: boolean = true;

  constructor(public dialogRef: MatDialogRef<SmallDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.data.showCloseButton ? this.data.showCloseButton : true;
  }

  doAction() {
    this.dialogRef.close({action: stringsList.doAction})
  }

  closeDialog() {
    this.dialogRef.close()
  }

}
